<div class="flex w-full flex-col pt-3 pb-5">
  <!-- ── Brand (mobile only, the fixed full-screen panel covers the nav bar's logo) ──── -->
  <div class="hidden max-sm:flex items-center justify-between px-4 pb-2 max-sm:mt-3">
    <a [routerLink]="AppRoutes.home()" (click)="close()">
      <img class="h-6 w-auto" [src]="platformLogoSrc" alt="givebrite" />
    </a>
    <button
      type="button"
      class="btn btn-sm btn-circle border border-base-300 bg-base-100 text-base-content shadow-sm hover:bg-base-200"
      (click)="close()"
    >
      <ui-icon name="x" [size]="20"></ui-icon>
    </button>
  </div>

  <!-- ── Search (mobile only, desktop already shows this in the main nav bar) ──── -->
  <ng-container *featureFlag="'header_search_is_enabled'">
    <div class="md:hidden max-sm:mt-[40px]">
      <div class="px-4 pt-6 pb-3">
        <gb-header-platform-search [light]="true"></gb-header-platform-search>
      </div>
    </div>
  </ng-container>

  <!-- ── Profile row (logged-in) ──────────────────────────────────────── -->
  @if (isUserLoading) {
    <div class="flex w-full items-center gap-3 px-5 pt-3 pb-2">
      <gb-header-user-profile [user]="" [isLoading]="true" size="md"></gb-header-user-profile>
    </div>
    <div class="mx-5 my-2 border-t border-base-300"></div>
  } @else if (user$ | async; as user) {
    <div class="flex w-full items-center gap-3 px-5 pt-3 pb-2">
      <gb-header-user-profile [user]="user" size="md"></gb-header-user-profile>
    </div>
    <div class="mx-5 my-2 border-t border-base-300"></div>
  }

  <button
    type="button"
    class="mx-2 flex cursor-pointer items-center gap-3 rounded-2xl px-3 py-2 text-left transition-colors hover:[background:var(--border-color-contrast)]"
    (click)="fundraise()"
  >
    <span class="flex size-9 shrink-0 items-center justify-center rounded-xl bg-mint text-ink">
      <ui-icon library="phosphor" name="plus" [size]="18"></ui-icon>
    </span>
    <span class="min-w-0 flex-1 text-sm font-bold">Start fundraising</span>
    <span class="badge badge-sm shrink-0 rounded-full border-none bg-lemon font-semibold whitespace-nowrap text-ink">0% fee</span>
  </button>

  <div class="mx-5 my-2 border-t border-base-300"></div>

  <!-- ── Grouped nav sections ─────────────────────────────────────────── -->
  <div class="flex flex-col px-2">
    <gb-header-nav-menu-section
      [items]="fundraisingItems"
      (linkClick)="close()"
    ></gb-header-nav-menu-section>

    <div class="mx-3 my-2 border-t border-base-300"></div>

    <gb-header-nav-menu-section
      title="For charities"
      [items]="charityItems"
      (linkClick)="close()"
    ></gb-header-nav-menu-section>

    <div class="mx-3 my-2 border-t border-base-300"></div>

    <gb-header-nav-menu-section
      [items]="supportItems"
      (linkClick)="close()"
    ></gb-header-nav-menu-section>
  </div>

  <!-- ── Auth / Account actions (always at bottom) ────────────────────── -->
  @if (isAuthenticated) {
    <div class="mx-5 my-2 border-t border-base-300"></div>
    <p class="px-5 pt-1 pb-1.5 text-xs font-semibold text-base-content/50">View dashboard as</p>
    <ul class="flex w-full flex-col px-2">
      @for (type of dashboardUserTypes; track type) {
        <li>
          <a
            class="flex cursor-pointer items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors hover:[background:var(--border-color-contrast)]"
            (click)="setDashboardUserType(type)"
          >
            <span class="flex w-9 shrink-0 justify-center">
              <ui-icon
                [name]="(dashboardUserType$ | async) === type ? 'circle-check' : 'user'"
                [size]="20"
              ></ui-icon>
            </span>
            {{ dashboardUserTypeLabels[type] }}
          </a>
        </li>
      }
      <li>
        <a
          class="flex cursor-pointer items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-error transition-colors hover:bg-error/10"
          (click)="logout()"
        >
          <span class="flex w-9 shrink-0 justify-center">
            <ui-icon name="log-out" [size]="20"></ui-icon>
          </span>
          Log Out
        </a>
      </li>
    </ul>
  } @else if (showGuestCtas) {
    <div class="grid grid-cols-2 gap-2 px-5 pt-3">
      <a
        class="btn rounded-full border-ink bg-base-100 text-sm font-semibold text-ink hover:[background:var(--border-color-contrast)]"
        [routerLink]="AppRoutes.auth.signup()"
        (click)="close()"
      >
        Sign up
      </a>
      <button
        type="button"
        class="btn rounded-full border-none bg-ink text-sm font-semibold text-white hover:bg-ink/90"
        (click)="goToLogin()"
      >
        Log in
      </button>
    </div>
  }
</div>
